import countries from 'world-countries';
import { parseLocation } from './locationUtils';

// Returns ISO-3166-1 alpha-3 (CCA3) code or null
export function resolveCountryCodeFromLocation(location) {
  if (!location) return null;

  // Object form
  if (typeof location === 'object') {
    // if provided as alpha-3 or alpha-2
    if (location.countryCode && typeof location.countryCode === 'string') {
      const code = location.countryCode.trim().toUpperCase();
      if (code.length === 3) return code;
      if (code.length === 2) {
        const c = countries.find(x => x.cca2.toUpperCase() === code);
        return c ? c.cca3 : null;
      }
    }
    // try by name
    const name = location.name || location.country || '';
    if (name) {
      const lower = name.toLowerCase().trim();
      const c = countries.find(x =>
        x.name.common.toLowerCase() === lower ||
        x.name.official.toLowerCase() === lower ||
        x.cca2.toLowerCase() === lower ||
        x.cca3.toLowerCase() === lower
      );
      if (c) return c.cca3;
    }
  }

  // String form
  if (typeof location === 'string') {
    const parsed = parseLocation(location);
    const countryName = parsed?.country || location;
    const lower = (countryName || '').toLowerCase().trim();
    const c = countries.find(x =>
      x.name.common.toLowerCase() === lower ||
      x.name.official.toLowerCase() === lower ||
      x.cca2.toLowerCase() === lower ||
      x.cca3.toLowerCase() === lower
    );
    if (c) return c.cca3;
  }

  return null;
}
